<template>
  <div>
    <div class="pc-course-theme">
      <!-- 课程系列头部管理 -->
      <div class="pc-course-theme-header">
        <h2>杂志主题管理</h2>
        <div class="pc-button-group">
          <el-button
            v-show="isEditting == false"
            class="pc-btn addbtn"
            @click="addTheme"
          >
            添加
          </el-button>
          <el-button
            @click="manageTheme"
            v-show="isEditting == false"
            class="pc-btn"
          >
            管理
          </el-button>
          <el-button @click="save" v-show="isEditting" class="pc-btn">
            完成
          </el-button>
        </div>
      </div>

      <el-dialog
        class="themeDialog"
        :title="magazineTopicDetailList.title"
        :visible.sync="isUpdateShow"
        width="30%"
      >
        <el-form label-width="80px">
          <el-form-item label="主题">
            <el-input v-model="magazineTopicDetailList.title"></el-input>
          </el-form-item>
          <el-form-item label="分类排序">
            <el-input-number
              v-model="magazineTopicDetailList.magazine_order"
            ></el-input-number>
          </el-form-item>
          <el-switch
            v-model="magazineTopicDetailList.status"
            active-color="#91CC75"
            inactive-color="#C7C7C7"
            :active-value="1"
            :inactive-value="0"
            style="margin-left: 40px"
          >
          </el-switch>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button
            class="dialog-footer-button-one"
            @click="isUpdateShow = false"
            >取 消</el-button
          >
          <el-button
            class="dialog-footer-button-second"
            type="primary"
            @click="submitBanner"
            >确 定</el-button
          >
        </span>
      </el-dialog>

      <!-- 课程系列管理 -->
      <ul class="theme-list">
        <li
          v-for="(item, index) in themeList"
          :key="index"
          class="theme-item"
          :class="item.status != 1 ? 'lost' : ''"
          @click="goThemePage(item)"
        >
          <div class="theme-item-content">
            <p class="name">{{ item.title }}</p>
            <p class="number">
              文章数：
              <span>
                {{ item.article_count }}
              </span>&nbsp;&nbsp;&nbsp;
                            排序：
              <span>
                {{ item.magazine_order }}
              </span>
            </p>

          </div>

          <div v-if="item.status != 1" class="lost-icon">无效</div>
          <!-- 点击编辑显示的修改样式 -->
          <div
            v-show="isEditting"
            @click="modifyTheme(item.id)"
            class="choice-delete"
          >
            <i class="el-icon-edit"></i>
          </div>
          <!-- 点击编辑显示的删除样式 -->
          <div
            v-show="isEditting"
            @click="deleteTheme(item.id)"
            class="choice-delete"
          >
            <i class="el-icon-circle-close"></i>
          </div>
        </li>
      </ul>
      <ul class="pagination" v-if="total > 12">
        <li
          v-for="(item, index) in Math.ceil(total / 12)"
          :key="index"
          :class="page == index + 1 ? 'choicePage' : ''"
          @click="changePage(index)"
        ></li>
      </ul>
      <DeleteDialog
        class="DeleteDialog"
        :dialogVisible="deleteDialogVisible"
        @isCancel="closeDelete"
        @isDelete="deleteConfirm"
      />
    </div>
    <div>
      <ArticleTable ref="magazine" :articleList="articleList" />
    </div>
  </div>
</template>

<script>
import DeleteDialog from "../../../componentSet/DeleteDialog";
import ArticleTable from "./ArticleTable";
import {
  magazineTopicList_Api,
  deleteMagazineTopicDetail_Api,
  getMagazineTopicDetail_Api,
  updateMagazineTopicDetail_Api,
  magazineArticleList_Api,
  magazineTopicDetail_Api,
} from "../../../../apis/magazine.api";
export default {
  props: ["magazineDetail"],
  data() {
    return {
      isEditting: false,
      deleteDialogVisible: false,
      themeList: [],
      page: 1,
      total: 0,
      articleList: [],
      isUpdateShow: false,
      deleteThemeID: null,
      magazineTopicDetailList: {
        // magazine:"",
        magazine_id: null,
        status: 0,
        magazine_order: null,
      },
    };
  },
  components: {
    DeleteDialog,
    ArticleTable,
  },
  mounted() {
    this.magazineTopicList();
  },
  methods: {
    addTheme() {
      this.isUpdateShow = !this.isUpdateShow;
      for (let key in this.magazineTopicDetailList) {
        this.magazineTopicDetailList[key] = null;
      }
      this.magazineTopicDetailList.status = 0;
    },
    submitBanner() {
      console.log();
      if (this.magazineTopicDetailList.magazine_classification_id == null) {
        this.magazineTopicDetailList.magazine_id = this.magazineDetail.id;
        getMagazineTopicDetail_Api(this.magazineTopicDetailList).then((res) => {
          console.log(res);
          this.magazineTopicList();
        });
        this.isUpdateShow = !this.isUpdateShow;
        return;
      } else {
        updateMagazineTopicDetail_Api(this.magazineTopicDetailList).then(
          (res) => {
            console.log(res);
            this.magazineTopicList();
          }
        );
        this.isUpdateShow = !this.isUpdateShow;
        return;
      }
    },
    magazineTopicList(hint) {
      magazineTopicList_Api(this.$route.query.id).then((res) => {
        hint ? this.$global.success(this, hint) : "";
        this.themeList = res.data;
        console.log(this.themeList);
        this.total = res.count;
      });
    },
    manageTheme() {
      this.isEditting = true;
    },
    save() {
      this.isEditting = false;
    },
    modifyTheme(id) {
      this.isUpdateShow = true;
      this.magazineTopicDetailList.magazine_classification_id = id;
      magazineTopicDetail_Api(id).then((res) => {
        this.magazineTopicDetailList = res.data;
        this.magazineTopicDetailList.magazine_classification_id =
          this.magazineTopicDetailList.id;
        console.log(this.magazineTopicDetailList.id);
      });
    },
    deleteTheme(id) {
      this.deleteThemeID = id;
      this.deleteDialogVisible = true;
    },
    closeDelete() {
      this.deleteDialogVisible = false;
    },
    goThemePage(item) {
      console.log(item)
      this.$refs.magazine.goTheme(item, function (item) {
        magazineArticleList_Api(item.id).then((res) => {
          this.articleList = res.data;
        });
      });
    },
    deleteConfirm() {
      deleteMagazineTopicDetail_Api({
        magazine_classification_id: this.deleteThemeID,
      }).then(() => {
        this.deleteDialogVisible = false;
        this.magazineTopicList();
      });
    },
    changePage(index) {
      this.page = index + 1;
      this.magazineTopicList(this.page, "获取系列成功");
    },
  },
};
</script>

<style scoped lang='scss'>
.pc-course-theme {
  @include box-model;
  .themeDialog {
    margin-top: 60px;
  }
  /deep/ .el-dialog__footer {
    .dialog-footer-button-one {
      @include manage-button;
      background: $test;
      color: $blueBtna;
    }
    .dialog-footer-button-second {
      @include manage-button;
    }
  }
  .DeleteDialog {
    margin-top: 60px;
  }
  .pc-course-theme-header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #c0c0c0;
    > h2 {
      font-size: 20px;
      padding-bottom: 15px;
      color: $mainTitle;
    }
    .pc-button-group {
      margin-top: -10px;
      .pc-btn {
        @include manage-button;
      }
      .addbtn {
        background: $test;
        color: $blueBtna;
      }
    }
  }

  .theme-list {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    margin-top: 30px;
    min-height: 180px;
    .theme-item {
      width: 22%;
      margin-right: 3%;
      height: 70px;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      display: flex;
      justify-content: space-between;
      margin-bottom: 15px;
      cursor: pointer;
      .theme-item-content {
        width: 80%;
        margin: 0;
        padding: 11px 10px 0 11px;
        .name {
          @include ellipsis;
          width: 100%;
          height: 14px;
          font-size: 14px;
          font-weight: 400;
          color: #434343;
          line-height: 14px;
        }
        .number {
          margin: 0;
          font-size: 10px;
          margin-top: 12px;
          span {
            display: inline-block;
            height: 14px;
            line-height: 14px;
            color: $lightenYellow;
          }
        }
      }
      .choice-delete {
        margin-right: 10px;
        height: 100%;
        display: flex;
        justify-content: center;
        border-radius: 0px 4px 4px 0;
        /deep/ .el-icon-edit {
          color: $timeBtn;
          align-self: center;
        }
        /deep/ .el-icon-edit:hover {
          color: $lightenYellow;
        }
        /deep/ .el-icon-circle-close {
          color: $timeBtn;
          align-self: center;
        }
        /deep/ .el-icon-circle-close:hover {
          color: $lightenYellow;
        }
      }
    }
    .lost {
      opacity: 0.44;
      position: relative;
      overflow: hidden;
      .lost-icon {
        position: absolute;
        width: 60px;
        top: 6px;
        left: -16px;
        text-align: center;
        background: $blueBtna;
        font-size: 10px;
        font-weight: 400;
        color: $base-color;
        transform: rotate(-45deg);
      }
    }
  }

  // // 课程系列换页
  .pagination {
    display: flex;
    justify-content: center;
    li {
      cursor: pointer;
      width: 34px;
      height: 5px;
      background: $schoolTagBorder;
      margin-right: 10px;
    }
    .choicePage {
      background: $blueBtna;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/guihua/components/MagazineThemeManagement.vue